export default "__VITE_ASSET__B3V6$1rR__"